export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Grey.78ee5dc8.jpg";